import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção dos demais relatórios de médico). */
export type DeclaracaoExteriorMedicoJob = ReportJob;
export type DeclaracaoExteriorMedicoJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Declaração para Apresentação no Exterior (Médico). */
@Injectable({ providedIn: 'root' })
export class DeclaracaoExteriorMedicoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'declaracao-exterior-medico-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.declaracaoExteriorMedico;
}
